import styled from "styled-components";

export const StatisticsBox = styled.div`
  width: 100%;
  min-height: calc(100vh - 100px);
  background-color: ${({ theme }) => theme.background.main};
  color: ${({ theme }) => theme.text.main} !important;
  border-radius: 12px;
  padding: 20px;

  .statistic_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;

    .title {
      display: flex;
      align-items: center;
      gap: 14px;

      span {
        font-size: 24px;
        color: ${({ theme }) => theme.text.main};
        font-weight: 600;
      }

      button {
        border-radius: 8px;
        height: 32px;
        min-width: 60px;
        outline: none;
        border: none;
        background-color: #0a84ff;
        color: #fff;
        cursor: default;
        font-size: 18px;
      }
    }

    .filter_side {
      display: flex !important;
      align-items: center !important;
      gap: 10px;

      .state_button {
        cursor: pointer;
        width: 42px;
        height: 42px;
        border-radius: 8px;
        background-color: ${({ theme }) => theme.background.primary};
        display: flex;
        justify-content: center;
        align-items: center;
        outline: none;
        border: none;
      }
    }
  }
  .chart_style {
    width: 100%;
    height: 70vh;
  }
  .pie_chart {
    width: 420px;
    height: 420px;
    canvas {
      width: 100% !important;
      height: 100% !important;
    }

    @media screen and (max-width: 1260px) {
      width: 350px;
      height: 350px;
    }

    @media screen and (max-width: 1098px) {
      width: 300px;
      height: 300px;
    }
  }

  .table {
    .table-scroll {
      max-height: 400px !important;
      overflow: auto;
    }
  }

  .chart_bottom {
    width: 100%;
    display: flex;
    gap: 18px;
    flex-wrap: wrap;

    .chart_bottom_box {
      width: 160px;
      height: 80px;
      border-radius: 12px;
      background-color: ${({ theme }) => theme.background.primary};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      b {
        font-size: 24px;
        color: ${({ theme }) => theme.text.main};
        font-weight: 600;
      }
      .reason {
        font-size: 14px;
        color: #999;
        display: flex;
        align-items: center;
        gap: 6px;

        span {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: rgb(29, 203, 206);
          display: block;
        }

        b {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
`;

export const CustomStyledIconButton = styled.button`
  border: none;
  outline: none;
  background-color: inherit;

  .hasSeen {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 8px;
    height: 8px;
    display: block;
    border-radius: 20px;
    background-color: red;
  }
`;
